import BreadCrump from "../tools/breadcrump";
import { getCookies } from "cookies-next";
import { useEffect, useState } from "react";
import axios from "axios";
import Swal from 'sweetalert2';
import { config } from "../../data/config";
import HeaderOfPage from "../tools/headerOfPage";
import { useTranslation } from 'react-i18next';
import { Link, useNavigate } from "react-router-dom";

const inputstyle = "py-3 px-5 block w-full border-gray-499 rounded text-sm border-blue-500 ring-blue-500 disabled:opacity-50 disabled:pointer-events-none";

export default function ListMarketplace() {
    const { t } = useTranslation();
    const navigate = useNavigate();
    let cookie = getCookies();
    const [list, setList] = useState<any>(null);
    const [title, setTitle] = useState<string>('');
    const [page, setPage] = useState(1);

    const breadcrump = [
        { name: 'Dashboard', url: '/dashboard' },
        { name: 'Marketplace Management', url: '/dashboard/Marketplace' },
        { name: 'List Marketplace', url: null },
    ];

    const loaddata = async (p = 1) => {
        try {
            const res = await axios({
                method: 'get',
                url: `${config.url}/v1/dashboard/marketplace?page=${p}&title=${title}`,
                headers: { Authorization: 'Bearer ' + cookie['token'] }
            });
            setList(res.data.message);
        } catch (error) {
            setList({ docs: [], totalPages: 0, page: 1, prevPage: null, nextPage: null });
        }
    };

    const deleted = async (id: string) => {
        const result = await Swal.fire({
            title: t("Are you sure?"),
            text: t("Delete this marketplace item?"),
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#3085d6",
            cancelButtonColor: "#d33",
            confirmButtonText: t("Yes, delete it!")
        });
        if (result.isConfirmed) {
            try {
                await axios({
                    method: 'delete',
                    url: config.url + '/v1/dashboard/marketplace/' + id,
                    headers: { Authorization: 'Bearer ' + cookie['token'] }
                });
                loaddata(page);
            } catch (error) {
                Swal.fire(t("Error"), t("Could not delete."), "error");
            }
        }
    };

    useEffect(() => {
        loaddata(page);
    }, [page]);

    return (
        <div className="text-left  bg-white  p-3 m-4 directions h-[100vh] mb-5 ">
            <BreadCrump data={breadcrump} />
            <HeaderOfPage name={t("Marketplace List")} />

            <div className="flex flex-col gap-4 mb-4">
                <div className="flex flex-wrap gap-2 items-center">
                    <label className="text-gray-700">{t("Title")}</label>
                    <input
                        value={title}
                        onChange={(e) => setTitle(e.target.value)}
                        className={inputstyle}
                        type="text"
                        placeholder={t("Search by title")}
                    />
                    <button
                        onClick={() => loaddata(1)}
                        className="bg-blue-600 hover:bg-blue-700 text-white font-semibold py-2 px-4 rounded"
                    >
                        {t("Filter")}
                    </button>
                    <button
                        type="button"
                        onClick={() => navigate('/dashboard/Marketplace/new')}
                        className="bg-green-600 hover:bg-green-700 text-white font-semibold py-2 px-4 rounded cursor-pointer"
                    >
                        {t("Add Marketplace")}
                    </button>
                </div>
            </div>

            <div className="-m-1.5 overflow-x-auto">
                <div className="p-1.5 min-w-full inline-block align-middle">
                    <table className="min-w-full divide-y divide-gray-200">
                        <thead>
                            <tr>
                                <th className="px-6 py-3 text-xs font-medium text-gray-500 uppercase">{t("Title")}</th>
                                <th className="px-6 py-3 text-xs font-medium text-gray-500 uppercase">{t("UserId")}</th>
                                <th className="px-6 py-3 text-xs font-medium text-gray-500 uppercase">{t("Active")}</th>
                                <th className="px-6 py-3 text-xs font-medium text-gray-500 uppercase">{t("Expired Date")}</th>
                                <th className="px-6 py-3 text-xs font-medium text-gray-500 uppercase">{t("Province")}</th>
                                <th className="px-6 py-3 text-xs font-medium text-gray-500 uppercase">{t("Commission")}</th>
                                <th className="px-6 py-3 text-xs font-medium text-gray-500 uppercase">{t("Action")}</th>
                            </tr>
                        </thead>
                        <tbody>
                            {list?.docs?.length > 0 ? list.docs.map((item: any) => (
                                <tr key={item.id} className="odd:bg-white even:bg-gray-100 hover:bg-gray-100">
                                    <td className="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-800">{item.title}</td>
                                    <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-800">{item.userId || '-'}</td>
                                    <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-800">{item.active ? t("Yes") : t("No")}</td>
                                    <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-800">{item.expiredDate ? new Date(item.expiredDate).toLocaleDateString() : '-'}</td>
                                    <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-800">{item.province || '-'}</td>
                                    <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-800">{item.commission ?? 20}%</td>
                                    <td className="px-6 py-4 whitespace-nowrap text-center text-sm font-medium flex gap-2">
<Link
                                                        to={`/dashboard/Marketplace/edit/${item.id || item._id}`}
                                                            className="inline-flex items-center gap-x-2 text-sm font-semibold rounded-lg border border-transparent text-blue-600 hover:text-blue-800"
                                                        >
                                                            <img src="/icons/editgreen.svg" width={20} alt="Edit" />
                                                        </Link>
                                        <button
                                            onClick={() => deleted(item.id || item._id)}
                                            className="inline-flex items-center gap-x-2 text-sm font-semibold rounded-lg border border-transparent text-red-600 hover:text-red-800"
                                        >
                                            <img src="/icons/delred.svg" width={20} alt="Del" />
                                        </button>
                                    </td>
                                </tr>
                            )) : (
                                <tr>
                                    <td colSpan={7} className="px-6 py-8 text-center text-gray-500">
                                        {t("No marketplace items found.")}
                                    </td>
                                </tr>
                            )}
                        </tbody>
                    </table>
                    {list && list.totalPages > 1 && (
                        <nav className="flex items-center gap-2 mt-4">
                            {list.prevPage != null && (
                                <button onClick={() => setPage(list.page - 1)} className="py-2 px-3 border rounded hover:bg-gray-100">
                                    {t("Previous")}
                                </button>
                            )}
                            <span className="px-3">{t("Page")} {list.page} / {list.totalPages}</span>
                            {list.nextPage != null && (
                                <button onClick={() => setPage(list.page + 1)} className="py-2 px-3 border rounded hover:bg-gray-100">
                                    {t("Next")}
                                </button>
                            )}
                        </nav>
                    )}
                </div>
            </div>
        </div>
    );
}
